$(function () {
  $('#modal').on('show.bs.modal', function (e) {
    const button = $(e.relatedTarget);
    const title = button.data('title') ? button.data('title') : '';
    const content = JSON.parse(button.data('content'));
    const video = button.data('video') ? button.data('video') : '';
    const offcanvas = button.data('offcanvas') ? button.data('offcanvas') : '';
    const modal = $(this);

    if (video) {
      modal.addClass('modal-video');
      $('body').addClass('modal-open-video');
    } else if (offcanvas) {
      modal.addClass('modal-offcanvas');
    }

    const modalLabel = modal.find('#modalLabel');
    if (title && modalLabel.length) {
      modalLabel.text(title);
    }
    modal.find('.modal-body').html(content);
  });

  $('#modal').on('hidden.bs.modal', function () {
    const modal = $(this);
    $('body').removeClass('modal-open-video');
    modal.removeClass('modal-video');
    modal.removeClass('modal-offcanvas');
    modal.find('.modal-body').html('');
  });

  // Gravity forms on submit
  $(document).on('gform_confirmation_loaded', function (e, formID) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'formSubmission',
      formID: formID,
      formName:
        !!window.suiteSevenGravityFormTitle &&
        !!window.suiteSevenGravityFormTitle[formID]
          ? window.suiteSevenGravityFormTitle[formID]
          : `Undefined - ${formID}`,
    });
  });

  // Play video on click
  var video = document.getElementById('sliderVideo');
  var button = document.getElementById('playButton');

  if (video && button) {
    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else if (!video.paused) {
        video.pause();
      }
    });

    video.addEventListener('play', function () {
      button.style.display = 'none';
    });

    video.addEventListener('pause', function () {
      button.style.display = 'block';
    });
  }

  $('.block-text-rotator[data-words]').each(function () {
    const el = this;
    const words = JSON.parse(el.dataset.words);
    if (words.length < 2) return;
    const track = el.querySelector('.block-text-rotator__word-track');
    const current = el.querySelector('.block-text-rotator__word--current');
    const next = el.querySelector('.block-text-rotator__word--next');
    let i = 0;
    setInterval(
      function () {
        const n = (i + 1) % words.length;
        next.textContent = words[n];
        track.classList.add('block-text-rotator__word-track--animate');
        track.addEventListener(
          'animationend',
          function () {
            track.classList.remove('block-text-rotator__word-track--animate');
            current.textContent = words[n];
            next.textContent = words[(n + 1) % words.length];
            i = n;
          },
          { once: true },
        );
      },
      parseInt(el.dataset.interval) || 3000,
    );
  });
});
